// Single source of truth for all copy + shared constants.

// All CTA buttons link here (Shopify checkout).
export const CART_LINK = 'https://tupolleriarentable.com/cart/53878176121196:1'

export const PRICE = {
  today: '$39.990',
  full: '$432.990',
  bonusesTotal: '$165.900',
}

export const IMAGES = {
  stack:
    'https://cdn.magicpatterns.com/uploads/gnoyo9tN7JVd9jXaBdAGkL/value-stack-1200.webp',
  og: 'https://cdn.magicpatterns.com/uploads/ntBzxhS8zjydmifYt1ShF7/og-polleria.jpg',
}

export const TOP_BAR = {
  prefix: '🔥 Precio Fundador Lanzamiento - quedan',
  suffix: '· después vuelve a $432.990',
  lastCall: '¡Últimos minutos!',
}

export const HERO = {
  brand: 'Pollería Rentable 2026',
  headline:
    'Montá y hacé rentable tu pollería en 30 días — con el mismo cajón que ya comprás',
  sub: 'No es un curso suelto: es el sistema completo para el pollero argentino. Formación, herramientas y — como fundador — un año gratis del primer software hecho exclusivamente para pollerías.',
  founderBadge: '⭐ Comprando hoy entrás al Programa Fundadores',
  stats: [
    { n: '11', l: 'Módulos' },
    { n: '+20', l: 'Videos' },
    { n: '3', l: 'Calculadoras' },
    { n: '11', l: 'Bonos' },
  ],
  rating: 'Cientos de polleros ya usando el sistema',
  verified: '✓ Compra verificada · Pago único',
  priceLabel: 'Precio de fundador',
  cta: '🛒 Quiero el sistema completo',
  ctaSub: 'Pago único. Sin cuotas mensuales. Acceso de por vida.',
  trust: [
    '🔒 Pago 100% seguro',
    '🛡 Garantía de 30 días',
    '💳 Mercado Pago · Tarjetas',
    '⚡ Acceso instantáneo',
  ],
  imgAlt:
    'Pollería Rentable 2026: los 11 módulos, las calculadoras y los bonos del sistema',
}

export const PAIN_INTRO = {
  from: 'Desde el escritorio de Franco',
  re: 'Re: Cómo hacer rentable tu pollería sin romperte la cabeza…',
  greeting: 'Estimado colega pollero,',
  question: '¿Alguna vez…?',
}

export const PAINS = [
  '¿Sentís que por más que te rompas laburando para otro, el techo de cuánto podés ganar ya está puesto de antemano?',
  '¿Pensaste «con lo que gano en un mes de laburo en blanco, podría estar armando algo mío»?',
  '¿Soñás con el día en que el que decide los horarios, los precios y las reglas seas vos y nadie más?',
  '¿Te preguntaste cuántos años más vas a esperar «el momento justo» para largarte a hacer algo propio?',
  '¿Soñás con un negocio de familia — donde tu pareja, tu hijo o tu hermano puedan sumarse y vivir de lo mismo que vos?',
  '¿Sentís que ya hiciste el esfuerzo de «empezar de cero» en un trabajo en blanco y aun así no ves la salida?',
  '¿Querés progresar de verdad, no solo sobrevivir el mes, y no sabés por dónde empezar sin plata de sobra?',
]

export const STORY_BLOCKS = [
  'Estos son los mismos problemas que yo enfrenté cuando recién arrancaba con un cajón de pollo prestado…',
  '…y son los mismos que siguen frenando hoy a cientos de polleros y polleras de barrio en toda la Argentina.',
]

export const PROBLEM_SECTION = {
  title: 'Acá está el gran problema…',
  intro:
    'Cuando yo arrancaba y buscaba ayuda para no fundirme, esto fue lo que encontré: la mayoría de los «consejos» gratis para poner una pollería son basura pura.',
  bullets: [
    'Los videos de YouTube y TikTok solo enseñan pollo a la brasa peruano — nada que ver con un mostrador argentino, un cajón crudo y un cliente que te discute el precio del kilo.',
    'Los «consejos» del cuñado, del vecino o del amigo que «una vez vendió pollo» — que nunca pusieron un peso propio ni sostuvieron un local un mes entero.',
    'Los cursos genéricos de emprendedurismo del Estado, llenos de power points y cero cancha — nunca te dicen cuánto rinde un cajón ni cómo detectar que te están metiendo agua por pollo.',
    'Pagarle todos los meses a un contador por algo que, con las herramientas correctas, resolvés vos mismo en cinco minutos desde el celular.',
  ],
  outro: [
    'Vi a un pibe abrir con toda la garra, comprar el cajón más caro pensando que así ganaba más, y terminar regalando la mitad del pollo porque no sabía calcular el rinde ni el precio de venta.',
    'Otro me contó que descubrió recién al tercer mes que el «pollo fresco» que le vendían pesaba distinto según el día — nadie le había explicado cómo pesar el hielo y el agua para no pagar de más.',
    'Así que agarré papel, calculadora y años de mostrador, y armé el cálculo real, cajón por cajón, para que no le pasara lo mismo a nadie más.',
  ],
}

export const SOLUTION_INTRO = {
  title: 'Así que decidí solucionar todo eso…',
  points: [
    'Con este sistema el techo de cuánto ganás lo ponés vos: te enseño a calcular tu rinde y tus precios reales para que cada cajón te deje lo que realmente vale tu trabajo.',
    'No hace falta esperar «el momento justo» ni tener una fortuna ahorrada: te muestro cuánto invertir y cómo arrancar de a poco, con lo que ya tenés.',
    'Es un sistema pensado para armar con tu familia, para que tu pareja, tu hijo o tu hermano puedan sumarse y vivir del mismo negocio que vos.',
    'Vos decidís los horarios, los precios y las reglas. Te doy las herramientas — calculadoras, trámites resueltos, proveedores — para que no dependa de la suerte.',
    'Este es el paso que te saca de «empezar de cero» otra vez: el mismo esfuerzo que ya venís poniendo, pero ahora construyendo algo tuyo.',
  ],
}

export const AUTHOR = {
  name: 'Franco',
  bio: 'Comerciante de toda la vida. Pasé de 2 cajones de pollo a tener mi propio local. Creador de Pollería Rentable 2026.',
  cta: '🛒 Quiero empezar hoy',
  ctaSub: 'Pago único de $39.990 · Garantía de 30 días',
}

export const PRODUCT_REVEAL = {
  kicker: 'Te presento…',
  name: 'Pollería Rentable 2026',
  tagline:
    '«El sistema completo para iniciar y hacer rentable tu negocio de venta de pollo»',
  promise:
    'Montá y hacé rentable tu pollería en 30 días — sacándole hasta un 30% más de ganancia al mismo cajón de pollo que ya estás comprando… aunque hoy no tengas ni idea de bromatología, ni sepas calcular un rinde, ni tengas un peso ahorrado de más.',
  question:
    '¿Qué hace que un sistema para poner una pollería sea realmente bueno?',
  answer:
    'Mirá las características y entendé por qué esto es diez veces mejor que cualquier «consejo» gratis que hayas visto.',
  cta: '🛒 Comprar ahora por $39.990',
  ctaSub: 'Acceso instantáneo · Garantía de 30 días',
}

export const FEATURES = [
  {
    tag: 'Característica #1',
    title: 'El módulo de los secretos',
    body: 'Te enseño, con el pollo en la mano, cómo detectar si el pollo que te venden viene inyectado con agua, cómo sacarle el máximo rinde a cada cajón y cómo no tirar ni los menudos.',
    note: 'Es como tener a un pollero de toda la vida parado al lado tuyo en el mostrador, mostrándote dónde está la plata que hoy dejás pasar.',
    img: 'https://cdn.magicpatterns.com/uploads/dnah3MvVQXMjHXF1iMUht1/feat-1-secretos-768.webp',
  },
  {
    tag: 'Característica #2',
    title: '3 calculadoras listas para usar desde el celu',
    body: 'Te llevás la Calculadora de Rinde del Pollo, la Calculadora para Marcar Precios y la Lista de Proveedores — todas listas para completar con tus propios números.',
    note: 'Se acabó lo de poner precios «a ojo». Vas a saber tu costo real por kilo antes de abrir la persiana cada mañana.',
    img: 'https://cdn.magicpatterns.com/uploads/eyK59X9GYByUaCLBXiPSha/feat-2-calculadoras-768.webp',
  },
  {
    tag: 'Característica #3',
    title: 'Habilitación, bromatología y cobros — paso a paso',
    body: 'La parte que nadie enseña: cómo resolver la habilitación municipal y la bromatología sin perderte en trámites, y cómo cobrar con Mercado Pago sin que las comisiones te coman la ganancia del día.',
    note: 'Cuando las instrucciones son así de claras, el trámite deja de ser una montaña. Se resuelve solo, un paso a la vez.',
    img: 'https://cdn.magicpatterns.com/uploads/evgdNHbfmYpvrCy7HHNgjs/12-700.jpg',
  },
  {
    tag: 'Característica #4',
    title: 'Método probado en la vida real, no en un aula',
    body: 'Todo adaptado a proveedores, precios y trámites argentinos — no a recetas peruanas ni a manuales genéricos traducidos de otro país.',
    note: 'Vas a ver exactamente cómo se hace, filmado por un pollero de verdad, no explicado por alguien que jamás pesó un cajón.',
    img: 'https://cdn.magicpatterns.com/uploads/oSSELYSYGhhc2SYQXfQYbx/feat-4-pollero-768.webp',
  },
  {
    tag: 'Característica #5',
    title: 'Sirve para el que empieza y para el que ya tiene un local',
    body: 'Hay módulos para el que arranca de cero y también para el que ya tiene su pollería hace años pero siente que labura para el proveedor y no le queda nada.',
    note: 'No hace falta que seas contador ni que tengas un local enorme. Hay un módulo hecho para tu situación.',
    img: 'https://cdn.magicpatterns.com/uploads/hneyTTvXXrn6GaTsCFtq5C/5-700.webp',
  },
]

export const TESTIMONIALS_INTRO = {
  title: 'Lo que dicen los que ya lo usan',
  sub: 'No quiero que te quedes solo con mi palabra. Mirá lo que cuentan algunos de los que ya usan Pollería Rentable 2026.',
}

export const TESTIMONIALS = [
  {
    title: '«El mejor sistema que vi para esto»',
    quote:
      '«Probé de todo: videos, cuñados, hasta un curso del municipio. Nada bajaba a la realidad del mostrador como esto. Las calculadoras solas ya me cambiaron el mes. Si estás por abrir, esto es una ganga.»',
    name: 'Rubén A.',
    location: 'La Matanza',
    img: 'https://cdn.magicpatterns.com/uploads/hj9jNbe8fYsAXELq3ABQyM/avatar-ruben-96.webp',
  },
  {
    title: '«Por fin entendí por qué no me quedaba plata»',
    quote:
      '«Tengo la pollería hace 4 años y pensaba que "así era el negocio". Con el módulo de rinde me di cuenta que estaba regalando casi el 20% del cajón sin saberlo. Ahora lo primero que hago cada mañana es la cuenta con la calculadora.»',
    name: 'Marisa D.',
    location: 'Rosario',
    img: 'https://cdn.magicpatterns.com/uploads/pQCPzws6akT14dcizJ3BeF/avatar-marisa-96.webp',
  },
  {
    title: '«Me sacó el miedo de encima»',
    quote:
      '«Lo que más me frenaba era la habilitación, pensaba que era un quilombo carísimo. Acá está explicado paso a paso, sin vueltas. Ya arranqué el trámite y no fue ni la mitad de lo que imaginaba.»',
    name: 'Walter C.',
    location: 'Córdoba',
    img: 'https://cdn.magicpatterns.com/uploads/pTbwcmxFbw6QagxUiLaNmb/avatar-walter-96.webp',
  },
  {
    title: '«Se nota que lo grabó alguien que labura de esto»',
    quote:
      '«No es un curso de power point. Es un pollero de verdad con el pollo en la mano, mostrándote todo. Eso se nota y se agradece.»',
    name: 'Yamila S.',
    location: 'San Miguel de Tucumán',
    img: 'https://cdn.magicpatterns.com/uploads/o2bQjkgsidJatnfiKxTaen/avatar-yamila-96.webp',
  },
]

export const INCLUDES_TITLE = 'Esto es todo lo que recibís con Pollería Rentable 2026'

export const INCLUDES = [
  {
    star: true,
    text: 'Pollería Rentable OS — 1 año gratis de acceso fundador a la beta del sistema, con todas las actualizaciones del año incluidas.',
    value: '(Valor incalculable)',
  },
  {
    star: true,
    text: 'Grupo Fundador Polleros Rentables — el primer grupo argentino solo para dueños de pollerías, acceso de por vida.',
    value: '(Valor incalculable)',
  },
  {
    star: true,
    text: 'Masterclass de Branding con IA en vivo — armá el nombre, el logo, los carteles y las fotos de tu local sin diseñador.',
    value: '(Valor incalculable)',
  },
  {
    star: false,
    text: '+20 videos en 11 módulos — de la mentalidad al mostrador, filmados por un pollero de verdad, con el pollo en la mano.',
    value: '($150.000)',
  },
  {
    star: false,
    text: 'El módulo de los secretos — cómo detectar pollo inyectado, sacarle el máximo rinde al cajón y no tirar ni los menudos.',
  },
  {
    star: false,
    text: 'Acceso de por vida — mirá los videos las veces que quieras, desde el celu, cuando lo necesites.',
  },
  {
    star: false,
    text: 'Trámites resueltos — habilitación, bromatología y cobros con Mercado Pago, paso a paso.',
  },
  {
    star: false,
    text: 'Método 100% argentino — adaptado a proveedores, precios y trámites reales, no a manuales de otro país.',
  },
]

export const FOUNDERS_INTRO = {
  badge: '⭐ Programa Fundadores',
  title: 'Entrás como fundador, no como un alumno más',
  sub: 'Los que compran durante este lanzamiento entran a un grupo cerrado que nunca se vuelve a abrir en estas condiciones. Estos tres bonos son solo para ellos.',
  cta: '🛒 Quiero entrar como fundador',
  ctaSub: 'Pago único de $39.990 · Garantía de 30 días',
}

export const FOUNDER_BONUSES = [
  {
    tag: '★ Bono principal de fundador',
    title: 'Pollería Rentable OS — 1 año de acceso gratis',
    desc: 'El primer sistema argentino pensado exclusivamente para pollerías. No es un programa de contaduría genérico adaptado a los ponchazos: está hecho para el que compra por cajón, vende por kilo y necesita saber hoy si le está quedando plata.',
    points: [
      'Un año completo de acceso gratis a la primera versión, desde el día que salga. Sin pagar un peso.',
      'Todas las actualizaciones de ese año incluidas. Cada función nueva que sumemos durante los 12 meses te entra sola, sin costo extra.',
      'Tu rinde guardado, cajón por cajón. Cargás el cajón y el sistema te guarda el historial: vas a ver cómo se te movió el costo real por kilo mes a mes, no de memoria.',
      'Precios de venta sugeridos por corte, calculados sobre tu costo real de esta semana, no sobre el del mes pasado.',
      'Registro de ventas del día y el reporte de qué corte te deja plata y cuál te la está comiendo.',
      'Precio de fundador congelado cuando termine el año. El que entra ahora nunca paga lo que va a pagar el que llegue después.',
      'Voz en qué se construye primero. Los fundadores dicen qué funciones necesitan y esas son las que salen antes.',
    ],
    footnote:
      'Te lo digo derecho: es una versión beta y se entrega por etapas. No te voy a prometer un sistema terminado el primer día. Lo que sí te prometo es que entrás gratis, que las mejoras del año te entran incluidas, y que lo vas a estar usando antes que nadie.',
  },
  {
    tag: '★ Bono de fundador',
    title: 'Grupo Fundador Polleros Rentables',
    desc: 'El primer grupo argentino dedicado exclusivamente a dueños de pollerías. Hoy el pollero está solo: si no le contás al de al lado (que es tu competencia), no tenés con quién hablar del negocio. Esto lo arregla.',
    points: [
      'Precios de cajón por zona, compartidos por los propios miembros. Vas a saber a cuánto está pagando el de otra provincia antes de sentarte a discutir con tu proveedor.',
      'Preguntás y te contesta gente que está en el mostrador hoy, no un profesor que nunca pesó un pollo.',
      'Aviso temprano cuando se mueve el precio del cajón, para que no te agarre de sorpresa con la lista vieja pegada en la pared.',
      'Proveedores nuevos y los que te fallaron, contados por los que ya pasaron por ahí.',
      'Acceso de por vida, también cuando entren los compradores que vengan después. Vos ya vas a estar adentro desde el principio.',
      'Sin vendedores ni spam. Solo polleros y gente que está por abrir.',
    ],
  },
  {
    tag: '★ Bono de fundador',
    title: 'Masterclass de Branding con IA, en vivo',
    desc: 'Una clase en vivo, solo para alumnos de Pollería Rentable, donde te muestro cómo armar toda la imagen de tu pollería usando inteligencia artificial — sin contratar a un diseñador y sin saber diseñar.',
    points: [
      'El nombre, el logo y los carteles de tu local, hechos con IA en el momento, gratis. Vas a salir de la clase con los tuyos.',
      'Fotos de tus productos que dan ganas de comprar, sin fotógrafo y sin estudio.',
      'Los carteles de precio y las promos que hacen frenar a la gente en la vereda.',
      'Tus publicaciones de Instagram y los estados de WhatsApp, armados en minutos y no en toda una tarde.',
      'En vivo, con preguntas. Traés tu caso y lo resolvemos ahí mismo.',
      'Queda grabada y te la llevás, por si ese día no podés estar.',
    ],
  },
]

export const BONUS_INTRO = {
  badge: '🎁 Y además, los 8 bonos de siempre',
  title: 'Reclamá también estos 8 bonos si comprás hoy',
  sub: 'Todo lo que ya venía con el sistema, incluido igual.',
  totalLabel: 'Solo en los 8 bonos de siempre te llevás',
  totalNote: 'más los 3 bonos de fundador, que no tienen precio',
  cta: '🛒 Quiero el sistema y los 11 bonos',
  ctaSub: 'Pago único de $39.990 · Garantía de 30 días',
}

export const BONUSES = [
  {
    n: 1,
    title: 'Calculadora de Rinde del Pollo',
    desc: 'Sacá tu costo real por kilo, sin adivinar. Es la misma planilla que uso yo para saber cuánto me queda de cada cajón antes de ponerle precio a la carne.',
    value: '$25.000',
  },
  {
    n: 2,
    title: 'Calculadora para marcar precios',
    desc: 'A cuánto vender cada corte para ganar de verdad, no para «cubrir gastos». Cargás tus números y te tira el precio de venta que te garantiza margen.',
    value: '$12.900',
  },
  {
    n: 3,
    title: 'Lista de proveedores',
    desc: 'La pieza clave para que no te claven precio ni te vendan pollo de dudosa procedencia. Un listado armado con años de mostrador.',
    value: '$20.000',
  },
  {
    n: 4,
    title: '«Qué hacer con lo que tirás»',
    desc: 'Mini-guía de aprovechamiento para que dejes de tirar plata junto con los descartes. Menudos, huesos y recortes que hoy tirás, mañana te generan un ingreso extra.',
    value: '$25.000',
  },
  {
    n: 5,
    title: 'Cómo crear y enlazar tu cuenta de Mercado Pago',
    desc: 'Paso a paso para crear tu cuenta y vincularla a tu POS, para cobrar en el mostrador sin vueltas.',
    value: '$15.000',
  },
  {
    n: 6,
    title: 'Cómo armar y exhibir tu batea',
    desc: 'Guía visual de cómo acomodar y exhibir los cortes de pollo en la batea para que se vendan solos.',
    value: '$18.000',
  },
  {
    n: 7,
    title: 'Guía de habilitación y bromatología',
    desc: 'PDF descargable con los requisitos generales de bromatología y habilitación para una pollería en Argentina (los requisitos municipales varían según la zona).',
    value: '$30.000',
  },
  {
    n: 8,
    title: 'Cómo conseguir tus primeros clientes al abrir',
    desc: 'PDF con 6 acciones simples para llenar tu pollería desde la primera semana: radio local, volanteo, grupos de Facebook, delivery, redes y estados de WhatsApp.',
    value: '$20.000',
  },
]

export const PRICING = {
  title: 'Entonces Franco, ¿cuánto cuesta esto?',
  intro:
    'Si sumás lo que cuesta un contador por mes, lo que perdés en cajones mal calculados y lo que te clavan los proveedores por no saber comparar precios, esto se paga solo la primera semana.',
  label: 'Precio de fundador · Solo durante el lanzamiento',
  rows: [
    { label: '+20 videos en 11 módulos', value: '$150.000' },
    { label: 'El módulo de los secretos del mostrador', value: '$60.000' },
    { label: 'Acceso de por vida y actualizaciones', value: '$57.090' },
    { label: 'Bono 1 · Calculadora de rinde del pollo', value: '$25.000' },
    { label: 'Bono 2 · Calculadora para marcar precios', value: '$12.900' },
    { label: 'Bono 3 · Lista de proveedores', value: '$20.000' },
    { label: 'Bono 4 · «Qué hacer con lo que tirás»', value: '$25.000' },
    { label: 'Bono 5 · Mercado Pago paso a paso', value: '$15.000' },
    { label: 'Bono 6 · Cómo armar y exhibir tu batea', value: '$18.000' },
    { label: 'Bono 7 · Guía de habilitación y bromatología', value: '$30.000' },
    { label: 'Bono 8 · Primeros clientes al abrir', value: '$20.000' },
  ],
  totalLabel: 'Valor de todo esto',
  founderRows: [
    { label: '★ Pollería Rentable OS · 1 año de acceso fundador' },
    { label: '★ Grupo Fundador Polleros Rentables · de por vida' },
    { label: '★ Masterclass de Branding con IA en vivo' },
  ],
  founderValue: 'Incalculable',
  note: 'Los tres bonos de fundador ni siquiera los cuento en el total, porque todavía no tienen precio.',
  kicker:
    'Todo el paquete por menos de lo que te deja un solo cajón bien calculado.',
  cta: '🛒 Comprar ahora',
  ctaSub: 'Esto es un pago único. No hay cuotas mensuales ni costos ocultos.',
  trust: [
    '🔒 Pago seguro',
    '🛡 Garantía 30 días',
    '💳 Mercado Pago · Tarjetas',
    '⚡ Acceso instantáneo',
  ],
}

export const GUARANTEE = {
  title:
    'No digas «sí». Solo decí «tal vez» y probalo sin riesgo por 30 días',
  paragraphs: [
    'Odio ver la palabra «garantía» pegada en todos lados. ¿Qué significa en realidad? Solo palabras. Frases hechas para que compres.',
    'Por eso no te hago solo una garantía. Te hago una promesa personal.',
    'Creo, de verdad, que este es el sistema más completo para montar y hacer rentable una pollería que existe hoy en la Argentina. Se me caería el alma al piso si sintieras que te decepcionó. Así que este es el trato:',
  ],
  badge: '🛡️',
  boxTitle: 'Mi garantía de 30 días: «ámalo o dejalo»',
  boxBody:
    'Si esto no es el recurso más completo que viste jamás para tu pollería, escribime y te devuelvo el 100% de tu plata. Sin preguntas. Esta es mi garantía de hierro de 30 días completos.',
}

export const FAQ_TITLE = '¿Tenés preguntas?'

export const FAQS = [
  {
    q: '¿Cómo accedo a los videos y las calculadoras? ¿Me llega algo a casa?',
    a: 'Todo es digital. Vas a cargar tus datos en la página siguiente y al toque tenés acceso a la plataforma con todos los videos, las 3 calculadoras y los 8 bonos. No hay cuota mensual de ningún tipo. Pagás una sola vez y eso es todo.',
  },
  {
    q: 'No tengo plata para arrancar en grande. ¿Esto me sirve igual?',
    a: 'Justamente por eso está armado así. No hace falta arrancar con el local más grande ni con la heladera más cara. Yo arranqué con un cajón prestado y de ahí salió todo. El sistema te muestra cómo escalar de a poco, sin fundirte en el intento.',
  },
  {
    q: '¿Hay alguna cuota mensual?',
    a: 'NO. Si entrás con esta oferta, es un pago único de $39.990 por acceso de por vida a todo el sistema y los bonos.',
  },
  {
    q: 'El software todavía no salió. ¿Qué me estás vendiendo exactamente?',
    a: 'Lo que comprás hoy y usás hoy es el sistema completo: los +20 videos en 11 módulos, las 3 calculadoras y los 8 bonos de siempre. Pollería Rentable OS es un bono de fundador: te da un año de acceso gratis a la beta desde el día que salga, con todas las actualizaciones de ese año incluidas. Es un extra por entrar ahora, no lo que sostiene la compra.',
  },
  {
    q: '¿Y si el software se atrasa o no sale?',
    a: 'Te lo digo derecho: es una versión beta y se entrega por etapas. Por eso el valor de tu compra está en el sistema que ya está listo y al que accedés al toque. Si el OS se demora, tu año de fundador arranca cuando salga, no antes, y las mejoras de ese año te entran igual. Y siempre tenés la garantía de 30 días para pedir el 100% de tu plata de vuelta.',
  },
  {
    q: '¿Por qué el precio de hoy es tan bajo comparado con el valor?',
    a: 'Porque es un lanzamiento y quiero armar el grupo de fundadores con gente que se decide rápido. Cuando esta oferta termine, el precio vuelve a $432.990. Para los que llegan a tiempo, es un pago único de $39.990.',
  },
  {
    q: '¿Y si recién estoy arrancando y no sé nada del tema?',
    a: 'Creo que cualquiera puede aprender a llevar una pollería rentable. El sistema arranca desde cero, explicando todo paso a paso, incluida la mentalidad antes que la técnica. Si podés seguir instrucciones simples, podés seguir este sistema.',
  },
  {
    q: 'Ya tengo mi pollería hace años. ¿Esto me sirve o es solo para el que arranca?',
    a: 'Te sirve especialmente a vos. Varios módulos están pensados justo para el que ya tiene el local pero siente que labura para el proveedor y no le queda nada — ahí es donde más plata se recupera con el módulo de rinde y las calculadoras.',
  },
  {
    q: '¿Cómo funciona la garantía? Quiero estar seguro de que es segura.',
    a: 'Solo debés compartir tus datos con quien confiás al 100%. Tu compra queda protegida con mi garantía de 30 días. Si no te convence por cualquier motivo, me escribís y te devuelvo el 100% de tu plata, sin preguntas ni letra chica.',
  },
  {
    q: '¿Por cuánto tiempo tengo acceso al sistema?',
    a: 'Tenés acceso de por vida a todos los videos, calculadoras y bonos. Tu acceso nunca vence y podés volver a mirar cualquier módulo cuando lo necesites.',
  },
]

export const FINAL_CTA = {
  badge: '⏳ La oferta está por terminar',
  title: 'La oferta especial de lanzamiento está por terminar',
  paragraphs: [
    'Te aviso: esta oferta de lanzamiento se va a cerrar y no vas a poder entrar a este precio después de eso, aunque quieras.',
    'Cuando termine, Pollería Rentable 2026 vuelve a su precio normal de $432.990.',
    'Pero acá, en esta página, el precio es un pago único de $39.990.',
    'En cuanto compres tenés acceso instantáneo a todos los videos, calculadoras y bonos. No hay que esperar ningún envío — podés empezar a mirar el primer módulo en los próximos minutos.',
  ],
  priceLabel: 'Precio de hoy',
  cta: '🛒 Comprar ahora',
  ctaSub: 'Pago único. Sin cuotas ni costos ocultos.',
  pd: 'P.D. — Recordá que contás con mi garantía de 30 días 100% sin riesgo. Estoy seguro de que vas a estar más contento que un domingo con la parrilla prendida y la pollería llena. Pero si por cualquier motivo no es así, no hay drama: tu inversión está protegida por 30 días completos.',
  pd2: 'P.D.2 — Esta es una oferta por tiempo limitado. Cuando termine el lanzamiento, el sistema vuelve a su precio normal.',
}

export const FOOTER = {
  brand: 'Pollería Rentable 2026',
  links: [
    'Términos y Condiciones',
    'Política de Privacidad',
    'Contacto',
    'Garantía',
  ],
  legal:
    '© 2026 Pollería Rentable 2026. Todos los derechos reservados. Este sitio no es parte de Facebook ni de ninguna plataforma de terceros.',
}

export const MOBILE_BAR = {
  cta: '🛒 Comprar ahora',
}
